class IntegrationLogEntry {
    id: number;
    date: Date;
    message: string;
    stackTrace: string;

    constructor(data?: Partial<IntegrationLogEntry>) {
        Object.assign(this, data);

        if (typeof this.date === "string")
            this.date = new Date(this.date);
    }
}

export default IntegrationLogEntry;